import React from 'react';
import { SiteUrlsProps } from '../../../app/selectors/SiteUrlsSelectors';
import { ModifiedDateMetadata, OwnerMetadata } from '../../../app/spaces/Header/HeaderMetadataRow';
import { ActionsMenuIcon, FavoriteToggleWithCountsIcon } from '../../../app/spaces/Header/HeaderNameRowIcons';
import { ConnectedSpaceHeader } from '../../../app/spaces/Header/SpaceHeader';
import { ISpaceItemDetailInfo } from '../../../ts/models/ISpaceItemDetailInfo';
import { FieldConceptIndexingErrorCode, FieldConceptIndexingStatusCode } from '../../../ts/ServerApi/requests/GetFieldConceptIndexingStatus';
import { IDataRoleActions } from '../../../ts/ServerApi/types/IDataRoleActions';
import { DataRoleStatusMetadata } from './DataRoleStatusMetadata';

export interface DataRoleSpaceHeaderProps extends SiteUrlsProps {
  readonly item: ISpaceItemDetailInfo<'dataRole'>;
  readonly availableActions: IDataRoleActions;
  readonly addToFavorites: () => void;
  readonly removeFromFavorites: () => void;
  readonly fieldConceptIndexingStatusCode: FieldConceptIndexingStatusCode;
  readonly fieldConceptIndexingErrorCode: FieldConceptIndexingErrorCode;
}

export function DataRoleSpaceHeader(props: DataRoleSpaceHeaderProps): JSX.Element {
  return <ConnectedSpaceHeader
      item={props.item}
      nameRowIcons={
        <>
          { FavoriteToggleWithCountsIcon({
            item: props.item,
            addToFavorites: props.addToFavorites,
            removeFromFavorites: props.removeFromFavorites,
          }) }
          {ActionsMenuIcon(props.item)}
        </> }
      availableActions={props.availableActions}
      metadataRow={
        <React.Fragment>
          { OwnerMetadata(props.item.owner, props.urls) }
          { ModifiedDateMetadata(props.item.updatedAt) }
          { DataRoleStatusMetadata(props.fieldConceptIndexingStatusCode, props.fieldConceptIndexingErrorCode) }
        </React.Fragment>
      }
  />;
}
